// Guided tour: the story the demo has to tell without us in the room.
// Each step names the route it lives on and a [data-tour] target;
// a step without a target is a centred popover.
export const tourSteps = [
  // Day overview: what is happening today.
  { id: 'welcome', route: '/kamiony' },
  { id: 'states', route: '/kamiony', element: '[data-tour="arrivals-states"]', side: 'bottom' },
  { id: 'perHour', route: '/kamiony', element: '[data-tour="arrivals-per-hour"]', side: 'bottom' },
  { id: 'banner', route: '/kamiony', element: '[data-tour="actions-banner"]', side: 'bottom' },
  // Akce: what the planner has to do, and what the system does for them.
  { id: 'queue', route: '/kamiony/akce', element: '[data-tour="actions-progress"]', side: 'bottom' },
  { id: 'urgency', route: '/kamiony/akce', element: '[data-tour="urgency-panel"]', side: 'left' },
  // Starts the simulated 13:00 check so the replies come in and the queue empties live.
  { id: 'replies', route: '/kamiony/akce', element: '[data-tour="urgency-log"]', side: 'left', action: 'runUrgency' },
  { id: 'stats', route: '/statistiky', element: '[data-tour="stats-kpis"]', side: 'bottom' },
  { id: 'carriers', route: '/statistiky/dopravci', element: '[data-tour="stats-carriers"]', side: 'top' },
  { id: 'restart', route: '/statistiky/dopravci', element: '[data-tour="tour-button"]', side: 'bottom' },
];
